import { AppState } from '@Redux/store';
import { Map } from '@Models';

export const getMap = (state: AppState): Map | null => state.map.entity ?? null;
